<div class="config-loading" *ngIf="!loaded">
    <div class="k-i-loading"></div>
</div>

<section class="config-section" *ngIf="loaded">
    <h3 class="config-section-title">
        OD Groups
        <span class="config-counter" *ngIf="odGroupsLoaded">{{ odGroups.length }} group{{ odGroups.length === 1 ? '' : 's' }} configured</span>
    </h3>

    <p class="config-counter config-note" *ngIf="!odGroupingEnabled">
        OD grouping is not enabled for your operation. Groups can be set up here, but
        nothing will apply them until it is switched on.
    </p>

    <p class="config-counter config-note" *ngIf="!odGroupsLoaded">
        Could not load the configured OD groups. Saving will leave them untouched.
    </p>

    <div class="config-warning" *ngIf="odGroupsLoaded">
        <span class="k-icon k-i-information"></span>
        <div>
            <strong>A child OD inherits the booking limits of its parent.</strong>
            <p>
                Each child OD can belong to only one parent, and groups are one level
                deep &mdash; a child OD cannot itself be a parent. Changes take effect
                on the next overnight run.
            </p>
        </div>
    </div>

    <!-- One form for both adding and updating. The dropdowns live here rather
         than in every grid row because a customer can have 200+ groups, and four
         dropdown components per row would be several hundred of them. -->
    <div class="od-group-form" *ngIf="odGroupsLoaded">
        <div class="config-setting">
            <label class="config-label">Parent OD</label>
            <kendo-dropdownlist class="config-control od-group-select"
                                [data]="originOptions"
                                [textField]="'name'"
                                [valueField]="'name'"
                                [valuePrimitive]="true"
                                [filterable]="true"
                                [(ngModel)]="parentOrigin"
                                (valueChange)="handleParentOriginChange()"></kendo-dropdownlist>
            <span class="od-group-dash">&ndash;</span>
            <kendo-dropdownlist class="config-control od-group-select"
                                [data]="destinationsFor(parentOrigin)"
                                [filterable]="true"
                                [disabled]="!parentOrigin"
                                [(ngModel)]="parentDestination"></kendo-dropdownlist>
        </div>

        <div class="config-setting">
            <label class="config-label">Child OD</label>
            <kendo-dropdownlist class="config-control od-group-select"
                                [data]="originOptions"
                                [textField]="'name'"
                                [valueField]="'name'"
                                [valuePrimitive]="true"
                                [filterable]="true"
                                [(ngModel)]="childOrigin"
                                (valueChange)="handleChildOriginChange()"></kendo-dropdownlist>
            <span class="od-group-dash">&ndash;</span>
            <kendo-dropdownlist class="config-control od-group-select"
                                [data]="destinationsFor(childOrigin)"
                                [filterable]="true"
                                [disabled]="!childOrigin"
                                [(ngModel)]="childDestination"></kendo-dropdownlist>
        </div>

        <div class="config-setting">
            <label class="config-label"></label>
            <button kendoButton
                    [disabled]="!odGroupFormComplete"
                    (click)="commitOdGroup()">{{ editingOdGroup ? 'UPDATE GROUP' : 'ADD GROUP' }}</button>
            <button kendoButton
                    *ngIf="editingOdGroup"
                    (click)="clearOdGroupForm()">CANCEL</button>
        </div>
    </div>

    <div class="config-setting" *ngIf="odGroupsLoaded">
        <label class="config-label">Filter</label>
        <input kendoTextBox
               class="config-control"
               placeholder="Parent or child OD"
               [value]="odGroupFilter"
               (input)="handleFilterOdGroups($any($event.target).value)"/>
    </div>

    <!-- kendoGridBinding rather than [data]: a plain array bound to [data] is not
         paged by the grid itself, so every group lands on one page and the pager is
         decorative. This directive does the slicing. scrollable none, and no fixed
         [height]: paging to 10 already bounds the height, so there is nothing to
         measure and nothing to get wrong. -->
    <kendo-grid *ngIf="odGroupsLoaded"
                class="od-group-grid"
                [kendoGridBinding]="odGroupsView"
                [pageable]="true"
                [pageSize]="10"
                [scrollable]="'none'">
        <kendo-grid-column title="Parent OD" [width]="160">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ odLabel(dataItem.parentOrigin, dataItem.parentDestination) }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Child OD" [width]="160">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{ odLabel(dataItem.childOrigin, dataItem.childDestination) }}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="" [width]="180">
            <ng-template kendoGridCellTemplate let-dataItem>
                <button kendoButton [look]="'flat'" (click)="editOdGroup(dataItem)">EDIT</button>
                <button kendoButton [look]="'flat'" (click)="removeOdGroup(dataItem)">REMOVE</button>
            </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridNoRecordsTemplate>
            {{ odGroups.length ? 'No groups match the filter.' : 'No OD groups configured.' }}
        </ng-template>
    </kendo-grid>

    <!-- Mirrors the API validation so a problem is visible as it is introduced.
         Save refuses while any of these stand. -->
    <div class="config-warning config-warning-error" *ngIf="odGroupErrors.length">
        <span class="k-icon k-i-warning"></span>
        <div>
            <strong>These must be fixed before the configuration can be saved.</strong>
            <ul>
                <li *ngFor="let error of odGroupErrors">{{ error }}</li>
            </ul>
        </div>
    </div>
</section>

<div class="config-actions" *ngIf="loaded">
    <button kendoButton [primary]="true" [disabled]="!odGroupsLoaded || saving" (click)="onSave()">
        <span *ngIf="saving" class="k-i-loading saving-icon"></span>{{ saving ? 'Saving...' : 'Save' }}
    </button>
</div>
